import React, { useState, useEffect, useRef, useMemo } from 'react';
import Search from '../../assets/search.png';
import Searchbar from '../../components/Search';
import Dropdown from '../../assets/dropdown.png';
import Eye from '../../assets/eye.png'
import Cookies from 'js-cookie'
import useApiPost from '../hooks/postData';
import formatTime from '../../components/formatTime'
import formatDate from '../../components/formatDate';
import { Link } from 'react-router-dom';
import Arrow from '../../assets/Showing_Arrow.png'
import DeactiveArrow from '../../assets/deactive_Arrow.png'
import Block from '../../assets/Block.png'
import Report from '../../assets/report_action.png'
import BlockUser from './BlockUser';
import { useNavigate, useLocation } from 'react-router-dom';
import Loader from '../../assets/Loader.gif'
import { useSelector } from 'react-redux';
import NoData from '../../assets/NoData.png'
import { updateUserStatus } from '../../store/slice/UserActiveDeactiveStatus';
import { useDispatch } from 'react-redux';

function UserList() {
  // Sample data for posts
  const [activePage, setActivePage] = useState(1)
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState("10");
  const [order, setOrder] = useState("")
  const [pagination, setPagination] = useState(null);
  const [category, setCategory] = useState()
  const dropdownRef = useRef(null);
  const [text, setText] = useState("")
  const [searchResults, setSearchResults] = useState([])
  const navigate = useNavigate()
  const [userId, setUserId] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [UserStatus, setUserStatus] = useState()
  const [selectedUser, setSelectedUser] = useState(null)
  const location = useLocation()
  const dispatch = useDispatch()
  const [actionLoading, setActionLoading] = useState(false)

  const handleOpenUserProfile = (userId) => {
    const currentPath = location.pathname.split("/")[1]; // gets 'reel-list', 'user-list', etc.
    setUserId(userId);
    Cookies.set("userId", userId);
    navigate(`/${currentPath}/user-profile`);
  };

  const statusMap = useSelector((state) => state.userStatus.statusMap);

  // Options for dropdown
  const options = ["10", "25", "50", "100"];

  // Function to handle option selection
  const handleSelect = (value) => {
    setSelectedValue(value);
    setIsDropdownOpen(false);
    setActivePage(1)
  };

  // for order and category
  const token = Cookies.get("Snapta_Admin_Token")

  const { data, error, postData } = useApiPost()

  // const handleGetUserList = async () => {
  //   setIsLoading(true)
  //     try {
  //         const payload = { page_no:activePage,per_page:selectedValue,order:order,category:category};
  //         if (text.trim() !== "") {
  //             payload.text = text;
  //         }
  //         const response = await postData("/get_all_user_pagination", payload);
  //         setSearchResults(response?.tag_users || []);
  //     } catch (error) {
  //         console.error("Error fetching user list:", error);
  //     } finally{
  //       setIsLoading(false)
  //     }
  // };

  const handleGetUserList = async (showFullLoader = true) => {
    if (showFullLoader) setIsPageLoading(true);
    try {
      const PageNo = selectedValue != 10 ? 1 : activePage
      const payload = {
        page_no: PageNo,
        per_page: selectedValue,
        order,
        category,
      };
      if (text.trim() !== "") {
        payload.text = text;
      }
      const response = await postData(`/get_all_user_pagination?per_page=${selectedValue}&page=${PageNo}`, payload);
      setSearchResults(response?.data.users || []);
      setPagination(response.data.pagination);
    } catch (error) {
      console.error("Error fetching user list:", error);
    } finally {
      if (showFullLoader) setIsPageLoading(false);
    }
  };

  // Refetch data when page number or search text changes
  useEffect(() => {
    console.log(activePage, 'activePage')
    const timer = setTimeout(() => {
      handleGetUserList();
    }, 500); // debounce delay

    return () => clearTimeout(timer); // cleanup on next run
  }, [text, activePage, selectedValue, order, category]);


  const [isPageLoading, setIsPageLoading] = useState(false);
  const [isActionLoading, setIsActionLoading] = useState(false);

  const handleDelete = async (newStatus) => {
    setIsActionLoading(true);
    try {
      dispatch(updateUserStatus({ userId: BlockUserId, status: newStatus }));
      await handleGetUserList(false); // Skip full page loader
    } catch (error) {
      console.error("Error updating user status:", error);
    } finally {
      setIsActionLoading(false);
    }
  };

  const [block, setBlock] = useState(false)
  const [BlockUserId, setBlockUserId] = useState("")
  const handleBlock = (UserId, UserStatus) => {
    setSelectedUser(UserId)
    setBlock(true)
    setBlockUserId(UserId)
    setUserStatus(UserStatus)
  }
  const handleCloseBlock = () => {
    setBlock(false)
  }


  const currentPage = pagination?.current_page
  const AllUserList = searchResults || [];


  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const isSidebarOpen = useSelector((state) => state.sidebar.isOpen);

  return (
    <>
      {/* <div className="mb-10 xl:pl-72"> */}
      <div className={`dark:bg-primary ${isSidebarOpen ? "xl:pl-20" : "xl:pl-72"}`}>
        <Searchbar />

        <div className='px-4 pb-10 xl:px-6'>

          {/* Title */}
          <div className="flex justify-between border-t-[#F2F2F2] pt-3">
            <h2 className="text-[#000000] font-poppins text-xl font-semibold dark:text-darkText my-auto">User List</h2>
            <div className="relative">
              <div className="absolute flex items-center p-2 transform -translate-y-1/2 left-2 top-1/2">
                <img src={Search} alt="Search" className="w-4 h-4 md:w-5 md:h-5" />
              </div>
              <input
                type="text"
                className="border border-gray-500 xl:placeholder:text-sm bg-[#00000005] dark:text-darkText placeholder:dark:text-tableDarkLarge border-opacity-10 rounded-lg md:w-[250px] w-[180px] py-2 pl-10 placeholder:text-sm placeholder:text-[#0000004F] focus:outline-none focus:ring-1 focus:ring-gray-600"
                placeholder="Search by stagename..."
                value={text}
                onChange={(e) => setText(e.target.value)}
              />
            </div>
          </div>

          {/* Navigation Path */}
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <Link to="/dashboard"><h3 className="text-[#3A3A3A] font-poppins text-base dark:text-darkText font-semibold">Dashboard</h3></Link>
              <div className="rounded-full w-1 h-1 bg-[#E0E0E0]"></div>
              <h3 className="text-[#858585] font-poppins text-base">User List</h3>
            </div>
          </div>

          {/* Header Bar */}
          <div className="border border-[#E3E3E3] dark:border-[#1F1F1F] rounded-lg mt-4 mx-4 sm:mx-0 overflow-x-auto w-full">
            <div className='xl:overflow-x-auto lg:overflow-x-auto 2xl:overflow-hidden min-w-[1200px] '>
              <div className='min-w-max'>
                {/* Table Header */}
                <div className="flex px-4 py-3 pl-4 text-left border-b dark:border-b-[#1F1F1F] dark:bg-darkHeader bg-header1 sm:pl-8">
                  <div className="w-[15%] text-headerText font-poppins text-sm font-semibold">S.L </div>

                  {/* Stagename (Previously Username) */}
                  <div className=" w-[80%] text-headerText font-poppins text-sm flex place-items-center gap-2 font-semibold">STAGENAME
                    {/* <div className='flex flex-col'>
                      <button onClick={() => { setOrder("0"); setCategory("Username"); }}>
                        <img src={category === "Username" && order === "0" ? Dropdown : DeactiveArrow} className={`w-2 h-2 rotate-180 transition`} />
                      </button>
                      <button onClick={() => { setOrder("1"); setCategory("Username") }}>
                        <img src={category === "Username" && order === "1" ? Dropdown : DeactiveArrow} className="w-2 h-2" />
                      </button>
                    </div> */}
                  </div>

                  {/* Date Time */}
                  <div className=" w-[55%] text-headerText font-poppins text-sm flex place-items-center gap-2 font-semibold">CREATED DATE/TIME
                    {/* <div className='flex flex-col'>
                      <button onClick={() => { setOrder("0"); setCategory("Date/Time") }}>
                        <img src={category === "Date/Time" && order === "0" ? Dropdown : DeactiveArrow} className={`w-2 h-2 rotate-180 transition`} />
                      </button>
                      <button onClick={() => { setOrder("1"); setCategory("Date/Time") }}>
                        <img src={category === "Date/Time" && order === "1" ? Dropdown : DeactiveArrow} className="w-2 h-2" />
                      </button>
                    </div> */}
                  </div>

                  {/* Login Type */}
                  <div className="w-[50%] text-headerText font-poppins text-sm flex place-items-center gap-2 font-semibold">LOGIN TYPE
                    {/* <div className='flex flex-col'>
                      <button onClick={() => { setOrder("0"); setCategory("Login type") }}>
                        <img src={category === "Login type" && order === "0" ? Dropdown : DeactiveArrow} className='w-2 h-2 rotate-180' />
                      </button>
                      <button onClick={() => { setOrder("1"); setCategory("Login type") }}><img src={category === "Login type" && order === "1" ? Dropdown : DeactiveArrow} className="w-2 h-2" /></button></div> */}
                  </div>

                  {/* Platform Type */}
                  {/* <div className="w-[40%] text-headerText font-poppins text-sm flex place-items-center gap-2 font-semibold">PLATFORM TYPE
    </div> */}

                  {/* Account Status */}
                  <div className='w-[45%] text-headerText font-poppins text-sm flex place-items-center gap-2 font-semibold'> ACCOUNT STATUS
                    {/* <div className='flex flex-col'>
        <button onClick={() => {setOrder("0"); setCategory("Login type")}}>
          <img src={category === "Login type" && order === "0" ? Dropdown : DeactiveArrow} className='w-2 h-2 rotate-180' />
        </button>
       <button><img src={category === "Login type" && order === "1" ? Dropdown : DeactiveArrow} className="w-2 h-2"/></button>
       </div> */}
                  </div>

                  {/* Report Count */}
                  <div className=' w-[45%] text-headerText font-poppins text-sm flex place-items-center gap-2 font-semibold'> TOTAL REPORTS
                    {/* <div className='flex flex-col'>
                      <button onClick={() => { setOrder("0"); setCategory("UserReport") }}>
                        <img src={category === "UserReport" && order === "0" ? Dropdown : DeactiveArrow} className='w-2 h-2 rotate-180' />
                      </button>
                      <button onClick={() => { setOrder("1"); setCategory("UserReport") }}>
                        <img src={category === "UserReport" && order === "1" ? Dropdown : DeactiveArrow} className="w-2 h-2" />
                      </button>
                    </div> */}
                  </div>

                  <div className="w-[30%] text-headerText font-poppins text-sm font-semibold">ACTIONS</div>
                </div>

                {/* Data Rows */}

                {isPageLoading ? (<div className='flex justify-center py-60'><img src={Loader} alt="loader" height={50} width={50} /></div>) :
                  (<>

                    {/* Check data if empty show No Data Image */}
                    {AllUserList?.length > 0 ?

                      //  AllUserList
                      (<>
                        {AllUserList?.map((user, index) => {
                          return (
                            <div key={user.id}
                              className={`${index % 2 === 0 ? 'bg-white dark:bg-primary' : 'bg-[#00162e0a] dark:bg-primary'} flex items-center px-4 py-3 sm:pl-8 pl-4 border-b dark:border-b-[#1F1F1F] last:border-0`}>

                              {/* Serial Number */}
                              <div className="w-[15%] dark:text-darkText text-[#000000] font-poppins text-sm">{(activePage - 1) * selectedValue + index + 1}</div>

                              {/* User name */}
                              <div className='w-[80%] flex gap-2 items-center'>
                                <img src={user.profile_pic} className='w-12 h-12 rounded-full object-cover' />
                                <div>
                                  <h2 className='text-[#00162e] dark:text-darkText font-poppins text-sm font-semibold cursor-pointer' onClick={() => handleOpenUserProfile(user.user_id)}>{user.username}</h2>
                                  <p className='text-xs text-[#939393] dark:text-tableDarkLarge light:text-tableLightLarge font-poppins'>{user.email === "" ? (user.mobile) : (user.email)}</p>
                                </div>
                              </div>

                              {/* Created Date */}
                              <div className='w-[55%]'>
                                <p className='text-[#00162e] dark:text-darkText text-sm font-poppins'>{formatDate(user.created_at)}</p>
                                <h2 className="text-[#777777] dark:text-tableDarkLarge font-poppins text-xs">{formatTime(user.created_at)}</h2>
                              </div>
                              {/* LOGIN TYPE */}
                              <div className="w-[50%]">
                                <p className={`font-poppins text-sm rounded-lg w-fit px-2
      ${{
                                    google: "text-[#00008B] bg-[#BCD2E8] bg-opacity-50",
                                    // background: #6C47B740;

                                    "Mobile Number": "text-[#452b7a] bg-[#452b7a] bg-opacity-10 dark:text-purple-300 dark:bg-[#452B7A] dark:bg-opacity-30",
                                    Email: "text-[#FFB117] bg-yellow-200 bg-opacity-35",
                                    facebook: "text-[#1877F2] bg-[#1877F2] bg-opacity-30",
                                    apple: "bg-[#EC5800] text-[#EC5800] bg-opacity-30",
                                  }[user.login_type] || "text-black bg-gray-300"}`}>
                                  {/* {user.login_type[0].toUppercase} */}
                                  {user.login_type ? user.login_type[0].toUpperCase() + user.login_type.slice(1) : ""}
                                </p>



                              </div>

                              {/* PLATFORM TYPE */}
                              {/* <div className='w-[40%]'>
        <h2 className='font-poppins dark:text-darkText text-[#00162e] text-sm'>Mobile</h2>
      </div> */}

                              {/* Account Status */}
                              <div className='w-[45%]'>
                                <h2
                                  className={`${true
                                    ? "text-[#0D9947] bg-[#0D9947] bg-opacity-20"
                                    : "text-red-500 bg-opacity-20 bg-red-500"
                                    } font-poppins text-sm w-fit rounded-lg px-2`}
                                >
                                  {true ? "Active" : "Deactive"}
                                </h2>
                              </div>

                              {/* Total Reports */}
                              <div className=' w-[45%]'>
                                <p className='font-poppins dark:text-darkText text-[#00162e] text-sm'>{user.user_report_count} {user.user_report_count > 1 ? "reports" : "report"}</p>
                              </div>

                              {/* Actions */}
                              <div className="w-[30%] flex gap-4">
                                {/* <button className="bg-[#CCE1CD] dark:bg-[#01D312] bg-opacity-[57%] dark:bg-opacity-[4%] rounded-full p-2" onClick={() => handleOpenUserProfile(user.user_id)}>
          <img src={Eye} className="w-4 h-4" />
        </button>
        <button className="bg-[#FDE4EA] dark:bg-[#FF3030] dark:bg-opacity-[6%] rounded-full p-2" onClick={handleOpen}>
          <img src={Delete} className="w-4 h-4" />
        </button> */}

                                <button className="bg-[#CCE1CD] dark:bg-[#01D312] border border-[#01D312] border-opacity-[20%] bg-opacity-[57%] dark:bg-opacity-[4%] rounded-full p-2" onClick={() => handleOpenUserProfile(user.user_id)}>
                                  <img src={Eye} className="w-4 h-4" />
                                </button>
                                {/* <button className="bg-[#FDE4EA] dark:bg-[#FF3030] border border-[#FF3030] border-opacity-[20%] dark:bg-opacity-[6%] rounded-full p-2" onClick={handleOpen}>
                  <img src={Delete} className='block w-4 h-4 dark:hidden'/>
                  <img src={Delete1} className='hidden w-4 h-4 dark:block'/>
                </button> */}

                                {/* <button className='bg-[#E4F1FF] border border-[#5891ce] border-opacity-[20%] rounded-full dark:bg-opacity-[2.5%] p-2' onClick={() => handleBlock(user.user_id,user.status)}>
        <img src={Block} className='block w-4 h-4 dark:hidden'/>
        <img src={Block1} className='hidden w-4 h-4 dark:block'/>
        </button> */}

                                <button className="bg-[#FDE4EA] dark:bg-[#FF3030] dark:bg-opacity-[6%] rounded-full p-2" onClick={() => handleBlock(user.user_id, user.status)}>
                                  <img src={Report} className='block w-4 h-4 dark:hidden' />
                                  <img src={Block} className='hidden w-4 h-4 dark:block' />
                                </button>
                              </div>
                            </div>
                          )
                        })}

                      </>) :

                      //  No User Found Image
                      (<>
                        <div className='flex flex-col justify-center py-32 2xl:py-36 place-items-center'>
                          <img src={NoData} alt="no data" className='w-96' />
                          <h2 className='font-poppins text-[#000000] text-sm font-semibold'>Don't have any data to show</h2>
                        </div>
                      </>)}
                  </>)}

                {/* Pagination and Results Count */}
                {AllUserList?.length > 0 ?

                  (<><div className="flex justify-between px-10 py-6 bg-white dark:bg-primary">
                    {/* Results Count */}
                    <div className="relative flex gap-2 place-items-center" ref={dropdownRef}>
                      {/* Dropdown Button */}
                      <div
                        className="border border-[#9C9C9C] bg-[#edeff166] dark:border-[#1F1F1F] dark:bg-primary rounded-xl flex gap-2 items-center px-3 py-1 cursor-pointer relative"
                        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                      >
                        <p className="text-[#00162e] dark:text-darkText font-poppins">{selectedValue}</p>
                        <button>
                          <img src={Arrow} className="w-4 h-4" />
                        </button>
                      </div>

                      {/* Dropdown Menu - Positioned Above */}
                      {isDropdownOpen && (
                        <div className="absolute left-0 z-50 mb-2 bg-white border dark:border-[#1F1F1F] dark:bg-primary border-gray-300 rounded-lg shadow-lg bottom-full w-max">
                          {options.map((option) => (
                            <p
                              key={option}
                              className="px-4 py-2 text-sm cursor-pointer dark:text-darkText hover:bg-gray-100"
                              onClick={() => handleSelect(option)}>
                              {option}
                            </p>
                          ))}
                        </div>
                      )}

                      {/* Results Text */}
                      <p className="text-[#333333] font-poppins text-sm dark:text-gray-600">
                        Showing <span className="font-semibold dark:text-darkText text-[#000000] text-sm">{pagination?.total}</span> results
                      </p>
                    </div>

                    {/* Pagination Buttons */}

                    <div className="flex items-center">
                      {/* Previous Button */}
                      <button
                        className={`text-[#000000] dark:text-darkText text-sm font-poppins px-3 py-1 rounded-full transition-all duration-200 
          ${pagination?.prev_page === 0 ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-200"}`}
                        onClick={() => setActivePage(prev => (prev > 1 ? prev - 1 : prev))}
                        disabled={pagination?.prev_page === 0}>
                        Previous
                      </button>

                      {/* Page Numbers */}
                      {[...Array(pagination.last_page)].map((_, index) => {
                        const page = index + 1;
                        return (
                          <button
                            key={page}
                            className={`text-sm font-poppins px-3 py-1 rounded-full transition-all duration-200 
              ${activePage === page ? "text-white bg-button-gradient" : "text-black dark:text-darkText hover:bg-gray-200"}`}
                            onClick={() => setActivePage(page)}
                          >
                            {page}
                          </button>
                        );
                      })}

                      {/* Next Button */}
                      <button
                        className={`text-[#000000] dark:text-darkText text-sm font-poppins px-3 py-1 rounded-full transition-all duration-200 
          ${pagination?.next_page > pagination.last_page ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-200"}`}
                        onClick={() => setActivePage(prev => (prev < pagination.last_page ? prev + 1 : prev))}
                        disabled={pagination?.next_page > pagination.last_page}
                      >
                        Next
                      </button>
                    </div>

                  </div></>) :

                  (<></>)}

              </div>
            </div>
          </div>

        </div>
      </div>
      {/* <DeleteUser open={open} handleClose={handleClose} handleDelete={handleDelete} /> */}
      {/* <BlockUser open={block} handleClose={handleCloseBlock} handleDelete={handleDelete} UserID={BlockUserId} UserStatus={userStatus}/> */}
      <BlockUser
        open={block}
        handleClose={handleCloseBlock}
        handleDelete={handleDelete}
        UserID={BlockUserId}
        UserStatus={statusMap[BlockUserId] ?? UserStatus}
      />
    </>
  );
}

export default UserList;
